<template>
  <div></div>
</template>

<script>
import Fct from "common/fct";

export default {
  name: "esocial-s3000",
  mixins: [Fct],
  components: {},

  props: {
    parent: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  watch: {
    "parent.response"() {
      this.formataLista();
    },
  },

  data() {
    return {
      tableHead: [
        {
          key: "empresa",
          sortable: true,
          show_fdt: true,
          show_empresa_link: true,
          label: "Empresa",
        },
        {
          key: "funcionario",
          sortable: true,
          show_funcao: true,
          show_funcionario_link: true,
          label: "Funcionário",
        },
         {
          key: "layout",
          sortable: true,
          label: "Layout Excluído",
        },
        {
          key: "recibo",
          sortable: true,
          label: "Recibo",
        },
        {
          key: "lote",
          sortable: true,
          show_lote_link: true,
          label: "Lote",
        },
        {
          key: "tipo_status",
          sortable: true,
          label: "Status",
        },
        {
          key: "updated_at",
          sortable: true,
          show_user: true,
          label: "Atualização",
          info: "Data da última alteração deste evento: mudança de status, geração de XML ou vínculo a lote.",
        },
      ],
    };
  },

  mounted() {
    this.formataLista();
  },

  methods: {
    formataLista: function () {
      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i]._nome = arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = (arrData[i].funcionario.funcao ? arrData[i].funcionario.funcao  : null);
        arrData[i].fdt = (arrData[i].funcionario.fdt ? arrData[i].funcionario.fdt  : null);
        arrData[i].consulta = (arrData[i].consulta ? arrData[i].consulta  : null);

        let lote = '';

        if(arrData[i].lote){
          lote = '<a target="_blank" href="/esocial/lotes/'+arrData[i].lote+'">';
          lote += '<span style="color:'+(arrData[i].tipo_status ? arrData[i].tipo_status.cor : '')+'"><i class="fa fa-plus"></i> Lote inclusão '+arrData[i].lote+'</span>';
          lote += '</a>';
        }

        var item = {
          consulta: arrData[i].id_con,
          id_con: arrData[i].id_con,
          layout: (arrData[i].parent ? arrData[i].parent.layout+'<br>'+arrData[i].parent.recibo : '---'),
          empresa: arrData[i].empresa.nome,
          funcionario: arrData[i].funcionario.nome,
          funcao: (arrData[i].funcao ? arrData[i].funcao.nome : null),
          fdt: arrData[i].fdt,
          id: arrData[i].id,
          lote:  (lote ? lote : '---'),
          recibo: '<span style="color:'+(arrData[i].tipo_status ? arrData[i].tipo_status.cor : '')+'">'+(arrData[i].recibo ? arrData[i].recibo : "---")+"</span>",
          updated_at:  '<span style="color:'+(arrData[i].tipo_status ? arrData[i].tipo_status.cor : '')+'">'+this.toDate(arrData[i].updated_at, false)+"</span>",
          dt_cad: '<span style="color:'+(arrData[i].tipo_status ? arrData[i].tipo_status.cor : '')+'">'+this.toDate(arrData[i].created_at, true)+"</span>",
          tipo_status: (arrData[i].tipo_status ? arrData[i].tipo_status.descricao : null),
          _data: arrData[i],
          buttons: [],
          options:{
              disable_delete: (
                true
              ),
            }
        };

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa-solid fa-file-circle-plus",
            color: "default",
            title: "Gerar arquivo XML",
            style: "font-size:12px;color:" + (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "#e03a3a"),
            click: this.parent.onEdit,
          });
        } else {
          item.buttons.push({
            icon: "fa fa-download",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML,
          });

          if (
            !arrData[i].lote
          ) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote,
            });
          }

          if (!arrData[i].recibo) {
            item.buttons.push({
              icon:  "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit,
            });
          }
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// s3000.vue?c5b6c074